var set_footer_cookie_offset;

function di_cookies( params ) {
	window.dataLayer = window.dataLayer || [];
	
	if( typeof set_dataLayer == 'undefined' ) {
		var set_dataLayer = function( json ){
			if( user_data && user_data.cookies == 'yes' ) {
				dataLayer.push( json );
			}
		};
	}
	
	if( typeof params !== 'object' ) params = {};
	
	let defaults = {
		session_cookie__yes					: 'yes',
		session_cookie__no					: 'no',
		gtm_cookie_consent					: 'cookie-consent',
		html_cookie_class__preinteract		: 'cookie-consent--preinteract',
		html_cookie_class__consent			: 'cookie-consent--consent',
		html_cookie_class__deny				: 'cookie-consent--deny',
		cookie_text__text					: '<p>This website stores cookies on your computer. These cookies are used to collect information about how you interact with our website and allow us to remember you. We use this information in order to improve and customize your browsing experience and for analytics and metrics about our visitors both on this website and other media. To find out more about the cookies we use, see our <a href="https://www.theleeco.com/privacy-policy/">Privacy Policy</a>. If you decline, your information won’t be tracked when you visit this website. A single cookie will be used in your browser to remember your preference not to be tracked.</p>',
		cookie_text__button_accept			: 'Accept Cookies',
		cookie_text__button_deny			: 'Deny Cookies',
		stylesheet							: 'https://www.theleeco.com/wp-content/themes/theleeco/library/dist/stylesheets/cookie-consent.css?v=2'
	};
	
	params = {
		...defaults,
		...params
	};
	
	var stored_cookie = browser_storage_get( 'stored_cookie' ) ? browser_storage_get( 'stored_cookie' ) : false;
	
	// SPACING
	var set_footer_cookie_offset = function() {
		if( $('html').is('.' + params.html_cookie_class__preinteract) ) {
			$('body').css('padding-bottom', $('#cookie-consent').outerHeight());
		} else {
			$('body').css('padding-bottom', 0);
		}			
	}
	
	var init = function() {
		
		// JQUERY	
		$(function(){
			
			// SET INITIAL COOKIE HTML CLASSES
			if( stored_cookie == params.session_cookie__yes ) {
				set_dataLayer({
					'event'		: params.gtm_cookie_consent
				});
				$('html').removeClass(params.html_cookie_class__preinteract + ' ' + params.html_cookie_class__deny).addClass(params.html_cookie_class__consent);
			} else if( stored_cookie == params.session_cookie__no ) {
				$('html').removeClass(params.html_cookie_class__preinteract + ' ' + params.html_cookie_class__consent).addClass(params.html_cookie_class__deny);
			} else {
				$('html').addClass(params.html_cookie_class__preinteract);
				setTimeout(function(){
					set_footer_cookie_offset();
				}, 100);
			}
			
			
			// INCLUDE STYLESHEET
			if( params.stylesheet ) {
				$('head').append('<link rel="stylesheet" type="text/css" href="' + params.stylesheet + '">');
			}
			
			$('body').append('<section id="cookie-consent"><div class="container"><div class="row align-items-center"><div class="col-md-8 cms cms--cookie-consent">' + params.cookie_text__text + '</div><div class="col-md-3 offset-md-1 mt-2 mt-md-0 text-center"><div><button href="#" class="btn btn--blue" data-consent-cookies="" data-ui-element="footer cookie consent">' + params.cookie_text__button_accept + '</button></div><small><a href="#" data-deny-cookies="" data-ui-element="footer cookie deny">' + params.cookie_text__button_deny + '</a></small></div></div></div></section>');
		
			$(window).on('resize', function(){
				set_footer_cookie_offset();
			}).trigger('resize');
			
			var consent_to_cookies = function(){

				browser_storage_set( 'stored_cookie', params.session_cookie__yes );

				stored_cookie = params.session_cookie__yes;
				
				$('html').removeClass(params.html_cookie_class__preinteract + ' ' + params.html_cookie_class__deny).addClass(params.html_cookie_class__consent);
				
				if( typeof check_switch_industry !== 'undefined' ) check_switch_industry( true );
				if( typeof resize_industry_nav !== 'undefined' ) resize_industry_nav();
				if( typeof set_industry_in_nav !== 'undefined' ) set_industry_in_nav();
				if( typeof set_user_units !== 'undefined' ) set_user_units();
				if( typeof user_data !== 'undefined' && user_data !== false ) {
					user_data.cookies = params.session_cookie__yes;
					browser_storage_set( 'user_data', JSON.stringify( user_data ) );
					update_session_localstorage();
					save_user_data();
				}

				set_dataLayer({
					'event'		: params.gtm_cookie_consent
				});
				
				$(window).trigger('resize');
			}
			
			var deny_cookies = function(){

				browser_storage_set( 'stored_cookie', params.session_cookie__no );
				stored_cookie = params.session_cookie__no;

				$('html').removeClass(params.html_cookie_class__preinteract + ' ' + params.html_cookie_class__consent).addClass(params.html_cookie_class__deny);
				if( typeof user_data !== 'undefined' && user_data !== false ) {
					user_data.cookies = params.session_cookie__no;
					save_user_data();
				}

				$(window).trigger('resize');
			}

			$(document).on('click', '[data-consent-cookies]', function(e){
				e.preventDefault();	
				consent_to_cookies();
				set_dataLayer({
					'event' 	: 'ui',
					'category'	: 'consent',
					'action'	: 'click',
					'label'		: $(this).attr('data-ui-element')
				});
			});

			$(document).on('change', 'input[type="checkbox"][name="cookie-consent"]', function(e){
				e.preventDefault();
				if( $(this).is(':checked') ) {
					consent_to_cookies();
					
					set_dataLayer({
						'event' 	: 'ui',
						'category'	: 'consent',
						'action'	: 'click',
						'label'		: $(this).attr('data-ui-element')
					});
				}
			})
		
			$(document).on('click', '[data-deny-cookies]', function(e){
				e.preventDefault();	
				
				deny_cookies();
				set_dataLayer({
					'event' 	: 'ui',
					'category'	: 'deny cookies',
					'action'	: 'click',
					'label'		: $(this).attr('data-ui-element')
				});
			});
		
		});
	}
	
	init();
}